import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import {
    faPause,
    faChevronUp,
    faChevronDown,
    faArrowLeft,
    faPenToSquare,
    faTrash,
    faPlay,
    faPlus,
    faUsd,
    faEye,
    faCheck,
    faHome,
    faCaretDown,
    faCaretUp,
    faChevronRight,
    faBars,
    faUser,
    faRobot,
    faBuildingColumns,
    faShop,
    faTimes,
    faClockRotateLeft,
    faMagnifyingGlass,
    faCircleQuestion,
    faFlask,
    faInfo,
    faDownload,
    faRightFromBracket,
    faSpinner,
    faFilter,
    faRightToBracket,
    faFloppyDisk,
    faSocks,
    faList,
    faStar,
    faMoneyBills,
    faStore,
    faCircleUser,
    faTrashCan,
    faSpellCheck,
    faBarsProgress,
    faHouse,
    faClock,
    faPlayCircle,
    faHourglassHalf,
    faTags,
    faSun,
    faMoon,
    faCircleInfo,
    faTriangleExclamation,
    faFileLines,
    faBell,
} from "@fortawesome/free-solid-svg-icons";
import { RouterService } from "../../../shared/_services/router.service";
import { PendingRequestInterceptor } from "../../../shared/_interceptors/pending-http-request.interceptor";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { Title } from "@angular/platform-browser";
import { ThemeService } from "../../../shared/_services/theme.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    standalone: false,
})
export class AppComponent implements OnInit {
    public showLoader: boolean = false;
    public showMenu: boolean = false;
    public showNavbar: boolean = false;

    constructor(
        private library: FaIconLibrary,
        private routerService: RouterService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private pendingRequestInterceptor: PendingRequestInterceptor,
        private titleService: Title,
        private themeService: ThemeService,
    ) {
        // Add an icon to the library for convenient access in other components
        pendingRequestInterceptor.pendingRequestsStatus.subscribe((status: boolean) => {
            setTimeout(() => {
                this.showLoader = status;
            });
        });
        library.addIcons(
            faSpinner,
            faHouse,
            faSocks,
            faList,
            faPause,
            faMoneyBills,
            faStore,
            faFloppyDisk,
            faRightToBracket,
            faFilter,
            faTimes,
            faChevronUp,
            faMagnifyingGlass,
            faFlask,
            faDownload,
            faRightFromBracket,
            faInfo,
            faCircleQuestion,
            faChevronDown,
            faClockRotateLeft,
            faArrowLeft,
            faPenToSquare,
            faUser,
            faRobot,
            faBuildingColumns,
            faShop,
            faBars,
            faTrash,
            faPlay,
            faPlus,
            faUsd,
            faEye,
            faCheck,
            faHome,
            faCaretDown,
            faCaretUp,
            faChevronRight,
            faStar,
            faCircleUser,
            faTrashCan,
            faSpellCheck,
            faBarsProgress,
            faClock,
            faPlayCircle,
            faHourglassHalf,
            faTags,
            faSun,
            faMoon,
            faFileLines,
            faBell,
            faCircleInfo,
            faTriangleExclamation,
        );
        routerService.init("/broker-accounts");
        router.events
            .pipe(
                filter((event) => {
                    return event instanceof NavigationEnd;
                }),
                map(() => this.activatedRoute),
                map((route: any) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    return route;
                }),
                filter((route: any) => route.outlet === "primary"),
                mergeMap((route: any) => route.data),
            )
            .subscribe((event: any) => {
                let title = "White Hat Bots Admin";
                if (event["title"]) {
                    title = `${event["title"]} - ${title}`;
                }
                this.titleService.setTitle(title);

                this.showNavbar = event["hideNavbar"] ? false : true;
            });
    }

    public ngOnInit(): void {
        // Initialize theme on component initialization
        this.themeService.getCurrentTheme();
    }
}
